import React from 'react'
import type { ContextProps } from './Context'
import { Provider } from './Context'
import { OrderContainer } from './OrderContainer'

export const Order = ({ ...props }: ContextProps) => {
  return (
    <Provider {...props}>
      <OrderContainer />
    </Provider>
  )
}
